// ── imports explicites (Phase 4B, générés puis maintenus à la main) ──
import { useEffect, useState } from "./00-boot.jsx";
import { localeForLang } from "./02-chat-translate-time.jsx";
// ⭐ CORRECTIF crash boot (19/07) : le pack de REPLI `fr` est BUNDLÉ (import inline
//   par esbuild), pas fetché. Sans ça, si le pack fr échouait au réseau (skew SW/
//   déploiement → 404 sur un hash purgé, ou réseau > 8 s), T.fr restait une coquille
//   vide et les ~125 accès DIRECTS `T[lang].nav.msg` (non protégés, contrairement à
//   tx()) plantaient sur undefined → ErrorBoundary « Une erreur est survenue » (prouvé
//   dans client_errors : Br.nav.msg / c.login). fr bundlé = T.fr TOUJOURS peuplé,
//   quoi qu'il arrive au réseau ⇒ repli infaillible. Seules en/de/pt restent lazy.
import LANAC_FR_PACK from "./i18n/fr.json";
// -------------------------------------------------------------------------------
// TRANSLATIONS
// -------------------------------------------------------------------------------
// ── T : coquilles par locale, PEUPLÉES AU RUNTIME par src/i18n/loader.jsx ────
//   Phase 1 lazy-load (2026-07-18) : le contenu vit dans src/i18n/<locale>.json
//   (source de vérité éditable, émis hashé dans dist/i18n/ par build.mjs, avec
//   SHA-256 au manifeste). Le loader REMPLIT ces objets par mutation AVANT le
//   premier rendu (22-nav attend lanacI18nReady) — les bindings const restent,
//   seul le contenu change. Les post-traitements historiques (merges PROFILE/
//   FLOW/ACCESS_REVIEW/FILTER_UI/I18N_EXTRA, clause terms.p) sont PRÉ-CALCULÉS
//   dans les packs (ex-tools/i18n-catalog.mjs, outil de migration retiré).
//   ⚠️ Ne JAMAIS réintroduire de littéraux ici : éditer src/i18n/*.json
//   (la garde tools/i18n-completeness.mjs prouve la parité des locales).
const T = { fr: (LANAC_FR_PACK && LANAC_FR_PACK.T) || {}, en: {}, de: {}, pt: {} };
const SEARCH_PAGE_TEXT={
  fr:{
    intro:"Choisissez une catégorie, puis LANAC adapte les filtres automatiquement.",
    bands:{
      immo:"Appartement, maison, studio, terrain",
      voiture:"Marque, modèle, carburant, budget",
      travaux:"Artisans, jardinage, nettoyage",
      autres:"Objets, électronique, meubles"
    },
    suggestions:{
      apartmentTitle:"Appartement à louer près de chez vous",
      apartmentSub:"Rayon 25 km, annonces disponibles",
      carTitle:"Voiture électrique",
      carSub:"Voitures disponibles, récentes en premier",
      nearSub:"Annonces autour de votre ville"
    },
    radius:n=>`Rayon : ${n} km`
  },
  en:{
    intro:"Choose a category, then LANAC adapts the filters automatically.",
    bands:{
      immo:"Apartment, house, studio, land",
      voiture:"Make, model, fuel, budget",
      travaux:"Tradespeople, gardening, cleaning",
      autres:"Items, electronics, furniture"
    },
    suggestions:{
      apartmentTitle:"Apartment for rent near you",
      apartmentSub:"25 km radius, available listings",
      carTitle:"Electric car",
      carSub:"Available cars, newest first",
      nearSub:"Listings around your city"
    },
    radius:n=>`Radius: ${n} km`
  },
  de:{
    intro:"Wählen Sie eine Kategorie, dann passt LANAC die Filter automatisch an.",
    bands:{
      immo:"Wohnung, Haus, Studio, Grundstück",
      voiture:"Marke, Modell, Kraftstoff, Budget",
      travaux:"Handwerker, Gartenarbeit, Reinigung",
      autres:"Artikel, Elektronik, Möbel"
    },
    suggestions:{
      apartmentTitle:"Wohnung zur Miete in Ihrer Nähe",
      apartmentSub:"25 km Umkreis, verfügbare Anzeigen",
      carTitle:"Elektroauto",
      carSub:"Verfügbare Autos, neueste zuerst",
      nearSub:"Anzeigen rund um Ihre Stadt"
    },
    radius:n=>`Umkreis: ${n} km`
  },
  pt:{
    intro:"Escolha uma categoria e a LANAC adapta os filtros automaticamente.",
    bands:{
      immo:"Apartamento, casa, estúdio, terreno",
      voiture:"Marca, modelo, combustível, orçamento",
      travaux:"Artesãos, jardinagem, limpeza",
      autres:"Objetos, eletrónica, móveis"
    },
    suggestions:{
      apartmentTitle:"Apartamento para arrendar perto de si",
      apartmentSub:"Raio de 25 km, anúncios disponíveis",
      carTitle:"Carro elétrico",
      carSub:"Carros disponíveis, mais recentes primeiro",
      nearSub:"Anúncios à volta da sua cidade"
    },
    radius:n=>`Raio: ${n} km`
  }
};
let ACTIVE_LANG="fr";
// Phase 4B : seul CE module réassigne sa variable (un import ESM est en lecture seule).
const setActiveLang=(l)=>{ACTIVE_LANG=l;};
const MISSING_TRANSLATION_KEYS=new Set();
const tx=(path,lang=ACTIVE_LANG)=>{
  // Phase 2 : `lang||ACTIVE_LANG` aligne tx sur la sémantique de langPick pour
  // un lang null/"" (langPick prenait ACTIVE_LANG ; tx retombait sur fr) — les
  // 734 sites migrés langPick→tx gardent ainsi un comportement identique.
  const root=T[lang||ACTIVE_LANG]||T.fr;
  const val=String(path).split(".").reduce((acc,k)=>acc&&acc[k],root);
  if(val!=null) return val;
  const miss=`${lang}:${path}`;
  if(!MISSING_TRANSLATION_KEYS.has(miss)){
    MISSING_TRANSLATION_KEYS.add(miss);
    if(typeof console!=="undefined"&&console.warn) console.warn(`Missing translation key: ${path} for language: ${lang}`);
  }
  return String(path).split(".").reduce((acc,k)=>acc&&acc[k],T.fr)||path;
};
// ── tp : PLURALISATION CLDR (Phase 4, 19/07) ─────────────────────────────────
//   Remplace les pluriels paresseux « résultat(s) » par une vraie flexion via
//   Intl.PluralRules (standard ECMA, ZÉRO octet, intégré au navigateur). Le pack
//   stocke T[lang].plural.<key> = { one:"{count} résultat", other:"{count} résultats"[,
//   few, many, zero, two] } — les CATÉGORIES CLDR. tp choisit la catégorie selon
//   le nombre ET la locale, retombe TOUJOURS sur `other` (obligatoire), et
//   interpole {count} avec un nombre formaté par locale (séparateurs de milliers).
//   ⭐ Future-proof : une langue à pluriel complexe (pl/ru/ar : one/few/many/other)
//   n'a qu'à fournir ses catégories dans son pack — Intl.PluralRules('pl') choisit
//   correctement, AUCUN code à changer. C'est la manière moderne (react-intl/CLDR).
const _pluralRulesCache={};
const pluralRulesFor=(lang)=>{
  const loc=localeForLang(lang||ACTIVE_LANG);
  if(!(loc in _pluralRulesCache)){ try{_pluralRulesCache[loc]=new Intl.PluralRules(loc);}catch(_){_pluralRulesCache[loc]=null;} }
  return _pluralRulesCache[loc];
};
const tp=(key,count,lang=ACTIVE_LANG)=>{
  const n=Number(count)||0;
  const node=((T[lang||ACTIVE_LANG]||T.fr).plural||{})[key] || (T.fr.plural||{})[key];
  if(!node||typeof node!=="object"){ // repli défensif : jamais de crash, jamais de vide
    if(!MISSING_TRANSLATION_KEYS.has(`plural:${key}`)){ MISSING_TRANSLATION_KEYS.add(`plural:${key}`); if(typeof console!=="undefined"&&console.warn) console.warn(`Missing plural key: ${key} for language: ${lang}`); }
    return `${n} ${key}`;
  }
  const pr=pluralRulesFor(lang);
  const cat=pr?pr.select(n):(n===1?"one":"other");
  const tmpl=node[cat]!=null?node[cat]:node.other;
  let num=String(n); try{ num=n.toLocaleString(localeForLang(lang)); }catch(_){}
  return String(tmpl==null?key:tmpl).replace(/\{count\}/g,num);
};
// ── tpCap (30/08) · pluriel PLAFONNÉ — le serveur compte au plus 1001 (listings_feed_count
//  LIMIT 1001, O(min(N,1001)) : au-delà de 1000, l'exactitude n'aide aucune décision et
//  coûtait O(N) — pattern Vinted/Leboncoin). Ce formateur rend le plafond lisible :
//  « 1 000+ résultat(s) ». Sous le plafond : délègue à tp, comportement inchangé.
const tpCap=(key,count,lang=ACTIVE_LANG,cap=1000)=>{
  const n=Number(count)||0;
  if(n<=cap) return tp(key,n,lang);
  const node=((T[lang||ACTIVE_LANG]||T.fr).plural||{})[key]||(T.fr.plural||{})[key];
  let num=String(cap); try{ num=cap.toLocaleString(localeForLang(lang)); }catch(_){}
  const tmpl=node&&typeof node==="object"?(node.other!=null?node.other:null):null;
  return tmpl==null?`${num}+ ${key}`:String(tmpl).replace(/\{count\}/g,num+"+");
};
// ── Traduction inverse pour notifications ───────────────────────────────────
//   Construit une fois une Map  "chaîne localisée" -> {fr,en,de,pt}  à partir de T (4 langues),
//   en parcourant les mêmes chemins de clés. Permet d'i18n-iser une notification SANS toucher
//   les ~95 call sites : pushNotice() reconnaît un titre/texte déjà traduit et restitue les 4 langues.
const NOTIF_REVERSE_T=new Map();
// Map "chaîne localisée" -> objet multilingue {loc:texte}, REMPLIE par le loader
// (src/i18n/loader.jsx). Sert les ~56 sites `pushNotice(tx("clé", lang), …)` : le
// COMPOSEUR rend une seule langue, la reverse-map restitue TOUTES les langues
// chargées pour que chaque destinataire lise la sienne (pushNotice → notifAutoI18n).
//   ⭐ Phase 3 (19/07) : l'objet `ml` est bâti sur Object.keys(perLocale) — les
//   locales RÉELLEMENT chargées — au lieu de {fr,en,de,pt} hardcodé. Conséquence :
//   une 5e langue précachée entre AUTOMATIQUEMENT dans la reverse-map, donc dans
//   les notifications, SANS toucher un seul de ces 56 sites. (Les 38 sites nL()
//   inline, eux, sont migrés vers nK() par le codemod — cf. i18n-notif-codemod.)
// Périmètre du parcours = T SANS profile/filterUi : reproduit l'ordre de
// construction HISTORIQUE (la map était bâtie avant ces fusions) → délta nul sur
// les chaînes reconnues, hors ~30 clés I18N_EXTRA (fusionnées dans ui/publishExtra/
// admin, indiscernables dans les packs — élargissement assumé et documenté).
const NOTIF_SKIP_SECTIONS=new Set(["profile","filterUi"]);
const lanacFillNotifReverse=(perLocale)=>{
  // Locales présentes (fr = repli, obligatoire = référence du parcours).
  const L=Object.keys(perLocale||{}).filter(l=>perLocale[l]&&typeof perLocale[l]==="object");
  if(!perLocale||!perLocale.fr||!L.length) return false;
  NOTIF_REVERSE_T.clear();
  const sub=(nodes,k)=>{ const o={}; L.forEach(l=>{o[l]=nodes[l]&&nodes[l][k];}); return o; };
  const walk=(nodes,depth)=>{ const ref=nodes.fr; if(!ref||typeof ref!=="object"||Array.isArray(ref)) return;
    Object.keys(ref).forEach(k=>{
      if(depth===0&&NOTIF_SKIP_SECTIONS.has(k)) return;
      const vals={}; let allStr=true, anyObj=false;
      L.forEach(l=>{ const v=nodes[l]&&nodes[l][k]; vals[l]=v; if(typeof v!=="string") allStr=false; if(v&&typeof v==="object"&&!Array.isArray(v)) anyObj=true; });
      if(allStr){ const ml={}; L.forEach(l=>{ if(vals[l]!=null) ml[l]=vals[l]; }); L.forEach(l=>{ const s=vals[l]; if(typeof s==="string"&&s&&!NOTIF_REVERSE_T.has(s)) NOTIF_REVERSE_T.set(s,ml); }); }
      else if(anyObj){ walk(sub(nodes,k),depth+1); }
    });
  };
  const root={}; L.forEach(l=>{root[l]=perLocale[l];});
  try{ walk(root,0); }catch(_){}
  return true;
};
// Convertit une chaîne déjà traduite en objet multilingue {fr,en,de,pt} si connue ; sinon renvoie tel quel.
const notifAutoI18n=v=>{ if(typeof v!=="string"||!v) return v; return NOTIF_REVERSE_T.get(v)||v; };
// -- SEED DATA -----------------------------------------------------------------
const N=Date.now();
const SEED=[
  {id:1,catId:"immo",adType:"sale",propType:"Appartement",title:"Appartement Lumineux 4P",city:"Luxembourg-Ville",price:850000,area:95,rooms:3,furnished:false,parking:true,img:"https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80",desc:"Superbe appartement au cÅ“ur de la capitale, parquet chêne, double vitrage, cave et parking inclus.",lat:49.611,lng:6.132,ownerId:"u2",status:"active",ts:N-86400000*3},
  {id:2,catId:"immo",adType:"rent",propType:"Appartement",title:"Appartement Meublé Centre",city:"Luxembourg-Ville",price:2400,charges:200,deposit:4800,area:70,rooms:2,furnished:true,parking:false,img:"https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&q=80",desc:"Bel appartement meublé, idéal pour expatriés, proche gares et commerces, charges incluses.",lat:49.609,lng:6.129,ownerId:"u3",status:"active",ts:N-86400000*1},
  {id:3,catId:"immo",adType:"sale",propType:"Maison",title:"Villa avec Jardin & Piscine",city:"Esch-sur-Alzette",price:1100000,area:210,rooms:5,furnished:false,parking:true,img:"https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&q=80",desc:"Villa contemporaine, piscine, jardin paysagé 1200m², garage double.",lat:49.495,lng:5.981,ownerId:"u3",status:"active",ts:N-86400000*5},
  {id:4,catId:"immo",adType:"rent",propType:"Studio",title:"Studio Moderne Gare",city:"Luxembourg-Ville",price:1200,charges:80,deposit:2400,area:32,rooms:0,furnished:true,parking:false,img:"https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600&q=80",desc:"Studio neuf entièrement équipé, cuisine américaine, proximité gare centrale.",lat:49.600,lng:6.135,ownerId:"u4",status:"rented",ts:N-86400000*10},
  {id:5,catId:"immo",adType:"sale",propType:"Terrain",title:"Terrain Constructible 600m²",city:"Differdange",price:320000,area:600,img:"https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&q=80",desc:"Terrain viabilisé zone résidentielle, permis de construire possible.",lat:49.524,lng:5.889,ownerId:"u2",status:"sold",ts:N-86400000*15},
  {id:6,catId:"immo",adType:"rent",propType:"Maison",title:"Maison 4 Chambres avec Jardin",city:"Ettelbruck",price:3200,charges:300,deposit:6400,area:180,rooms:4,furnished:false,parking:true,img:"https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=600&q=80",desc:"Belle maison familiale, grand jardin, garage, cave, quartier calme.",lat:49.847,lng:6.101,ownerId:"u3",status:"active",ts:N-86400000*2},
  {id:7,catId:"voiture",adType:"sale",propType:"Berline",title:"BMW Série 3 320d",city:"Luxembourg-Ville",price:24500,brand:"BMW",model:"Série 3",year:2019,mileage:68000,fuel:"Diesel",img:"https://images.unsplash.com/photo-1555215695-3004980ad54e?w=600&q=80",desc:"Très bon état, carnet complet, jantes alliage, toit ouvrant.",lat:49.610,lng:6.130,ownerId:"u3",condition:"Très bon état",status:"active",ts:N-86400000*4},
  {id:8,catId:"voiture",adType:"sale",propType:"SUV",title:"Tesla Model Y Long Range",city:"Esch-sur-Alzette",price:42000,brand:"Tesla",model:"Model Y",year:2022,mileage:18000,fuel:"Électrique",img:"https://images.unsplash.com/photo-1617788138017-80ad40651399?w=600&q=80",desc:"Autopilot, 2 clés, premium audio, garantie constructeur restante.",lat:49.495,lng:5.982,ownerId:"u4",condition:"Très bon état",status:"reserved",ts:N-86400000*2},
  {id:9,catId:"travaux",adType:"service",propType:"Peinture",title:"Peinture intérieure appartement",city:"Luxembourg-Ville",price:3500,urgent:true,img:"https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?w=600&q=80",desc:"Peinture complète 4 pièces, murs et plafonds, peinture fournie.",lat:49.611,lng:6.132,ownerId:"u2",status:"active",ts:N-86400000*1},
  {id:10,catId:"travaux",adType:"service",propType:"Jardinage",title:"Entretien jardin & haies",city:"Ettelbruck",price:80,urgent:false,img:"https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80",desc:"Taille haies, tonte pelouse, débroussaillage. Tarif horaire.",lat:49.847,lng:6.101,ownerId:"u3",status:"active",ts:N-86400000*3},
  {id:11,catId:"autres",otherCat:"electronique",adType:"sale",title:"iPhone 15 Pro 256Go",city:"Luxembourg-Ville",price:850,img:"https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=600&q=80",desc:"État impeccable, avec boîte et accessoires d'origine.",lat:49.609,lng:6.131,ownerId:"u4",condition:"Très bon état",status:"active",ts:N-3600000*5},
  {id:12,catId:"autres",otherCat:"loisirs",adType:"sale",title:"VTT Trek Marlin 7 — Taille L",city:"Differdange",price:620,img:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80",desc:"29 pouces, freins hydrauliques, full Shimano, révision faite.",lat:49.524,lng:5.888,ownerId:"u3",condition:"Bon état",status:"active",ts:N-86400000*6},
];
const DEMO_USERS=[
  {id:"u1",name:"Admin LANAC",email:"admin@lanac.lu",color:"var(--color-primary)",role:"Admin",verified:true,emailVerified:true,phone:"+352 621 000 001",phoneVerified:true},
  {id:"u2",name:"Marie Weber",email:"marie@mail.lu",color:"var(--color-success)",role:"Annonceur",verified:true,emailVerified:true,phone:"+352 621 000 002",phoneVerified:true},
  {id:"u3",name:"Paul Schmit",email:"paul@mail.lu",color:"var(--color-info)",role:"Professionnel",verified:true,emailVerified:true,phone:"+352 621 000 003",phoneVerified:true},
  {id:"u4",name:"Anna Klein",email:"anna@mail.lu",color:"var(--color-primary)",role:"Particulier",verified:false,emailVerified:false,phoneVerified:false},
];
const SEED_CONVOS=[
  {id:"c1",participants:["u2","u3"],refId:1,refTitle:"Appartement Lumineux 4P",refCat:"immo",messages:[
    {id:"m1",from:"u3",text:"Bonjour, l'appartement est encore disponible ?",ts:N-18000000},
    {id:"m2",from:"u2",text:"Oui ! Vous souhaitez une visite ?",ts:N-14400000},
    {id:"m3",from:"u3",text:"Samedi matin ce serait parfait.",ts:N-7200000},
  ]},
  {id:"c2",participants:["u3","u4"],refId:7,refTitle:"BMW Série 3 320d",refCat:"voiture",messages:[
    {id:"m4",from:"u4",text:"Le prix est-il négociable ?",ts:N-86400000},
    {id:"m5",from:"u3",text:"Légèrement oui, venez la voir !",ts:N-82800000},
  ]},
];

const SEED_REVIEWS=[
  {id:"rv1",sellerId:"u2",reviewerId:"u3",rating:5,comment:"Très réactif, annonce conforme à la description. Je recommande !",ts:N-86400000*2},
  {id:"rv2",sellerId:"u2",reviewerId:"u4",rating:4,comment:"Bonne transaction, vendeur sérieux et ponctuel.",ts:N-86400000*5},
  {id:"rv3",sellerId:"u3",reviewerId:"u2",rating:5,comment:"Professionnel et honnête, très bonne expérience.",ts:N-86400000*1},
  {id:"rv4",sellerId:"u3",reviewerId:"u4",rating:3,comment:"Correct mais peu flexible sur le prix.",ts:N-86400000*8},
  {id:"rv5",sellerId:"u4",reviewerId:"u3",rating:5,comment:"Parfait, objet exactement comme sur les photos.",ts:N-3600000*10},
];
const SEED_DEALS=[
  {id:"d1",itemId:5,itemTitle:"Terrain Constructible 600m²",sellerId:"u2",buyerId:"u3",kind:"vendu",sellerConfirmed:true,buyerConfirmed:true,status:"confirmed",ts:N-86400000*4},
  {id:"d2",itemId:4,itemTitle:"Studio Moderne Gare",sellerId:"u4",buyerId:"u3",kind:"loué",sellerConfirmed:true,buyerConfirmed:true,status:"confirmed",ts:N-86400000*7}
];

// -- GEO ----------------------------------------------------------------------
const GEO={minLon:5.73,maxLon:6.53,minLat:49.44,maxLat:50.18};
const toXY=(la,ln)=>({x:((ln-GEO.minLon)/(GEO.maxLon-GEO.minLon))*740+30,y:((GEO.maxLat-la)/(GEO.maxLat-GEO.minLat))*520+30});
const pts=arr=>arr.map(p=>`${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");
const LUX=[[50.178,5.977],[50.165,6.013],[50.132,6.023],[50.093,6.14],[50.058,6.2],[50.003,6.23],[49.96,6.332],[49.91,6.397],[49.86,6.418],[49.82,6.39],[49.8,6.35],[49.76,6.34],[49.72,6.31],[49.68,6.28],[49.64,6.22],[49.55,6.14],[49.48,6.06],[49.445,5.973],[49.454,5.858],[49.48,5.82],[49.54,5.777],[49.6,5.78],[49.66,5.74],[49.72,5.76],[49.78,5.82],[49.84,5.86],[49.9,5.9],[49.96,5.9],[50.02,5.94],[50.08,5.96],[50.178,5.977]].map(([a,b])=>toXY(a,b));
const BEL=[[50.18,5.73],[50.18,5.977],[50.08,5.96],[50.02,5.94],[49.96,5.9],[49.9,5.9],[49.84,5.86],[49.78,5.82],[49.72,5.76],[49.66,5.74],[49.6,5.78],[49.54,5.777],[49.48,5.82],[49.454,5.858],[49.445,5.973],[49.44,5.73]].map(([a,b])=>toXY(a,b));
const FRA=[[49.44,5.73],[49.445,5.973],[49.48,6.06],[49.55,6.14],[49.64,6.22],[49.68,6.28],[49.44,6.53]].map(([a,b])=>toXY(a,b));
const DEU=[[49.68,6.28],[49.72,6.31],[49.76,6.34],[49.8,6.35],[49.82,6.39],[49.86,6.418],[49.91,6.397],[49.96,6.332],[50.003,6.23],[50.058,6.2],[50.093,6.14],[50.132,6.023],[50.165,6.013],[50.18,6.013],[50.18,6.53],[49.44,6.53],[49.68,6.28]].map(([a,b])=>toXY(a,b));

// -- HELPERS -------------------------------------------------------------------
const fmtTime=ts=>{const d=new Date(ts),diff=Date.now()-d,loc=localeForLang(ACTIVE_LANG);if(diff<60000)return"•";if(diff<3600000)return`${Math.floor(diff/60000)}m`;if(diff<86400000)return d.toLocaleTimeString(loc,{hour:"2-digit",minute:"2-digit"});return d.toLocaleDateString(loc,{day:"2-digit",month:"2-digit"});};
const fmtHour=ts=>new Date(ts).toLocaleTimeString(localeForLang(ACTIVE_LANG),{hour:"2-digit",minute:"2-digit"});
const genId=()=>Math.random().toString(36).slice(2,10);
const esc=s=>String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
// ⚠️ A11y/visuel (30/08) : ce SVG est servi COMME IMAGE (<img src=data:>) — document
//  isolé, AUCUNE variable CSS de la page n'y est résoluble. Les var() d'origine
//  retombaient sur du NOIR (fill invalide) ⇒ pavé noir à la place du placeholder
//  (audit 28/08).
// (08/10/2026) UN SEUL DESSIN « SANS PHOTO ». C'était un cadre crème de 800 × 960 au mot « Photo » écrit en français ; la
//  coquille en avait un autre (gris froid, window.LANAC_IMG_FB) : deux dessins selon l'écran. C'est désormais LE MÊME, au
//  caractère près (banc le-meme-principe-partout) : le soleil et les montagnes, sans texte, discrets (62 % de la taille de
//  l'ancien pictogramme, qui occupait 70 % de la largeur d'une carte). Il est TRANSPARENT et son fond
//  est posé par la feuille de style (img[src*="lnc-sans-photo"], des jetons) : il suit le thème sans qu'aucune variable
//  n'ait à entrer dans l'image ; seul son trait est figé (un gris chaud à 42 %, lisible sur les deux fonds).
//  ⚠️ Jamais écrit en base (vérifié le 08/10 : aucune annonce ne porte une image « data: ») — une marque en mémoire seulement.
const NO_PHOTO_IMG="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20id='lnc-sans-photo'%20width='100'%20height='100'%20viewBox='0%200%20100%20100'%3E%3Cg%20transform='translate(19%2019)%20scale(.62)'%20opacity='.42'%20fill='%238a8174'%20stroke='%238a8174'%20stroke-width='3'%20stroke-linejoin='round'%3E%3Ccircle%20cx='38'%20cy='38'%20r='6'/%3E%3Cpath%20d='M21%2069l19-21%2013%2014%2010-11%2016%2018z'/%3E%3C/g%3E%3C/svg%3E";
function useIsMobile(max=900){
  const get=()=>{
    if(typeof window==="undefined") return false;
    const visual=window.visualViewport?.width||window.innerWidth||9999;
    const screenW=window.screen?.width||9999;
    return visual<=max||screenW<=max||(window.matchMedia&&window.matchMedia(`(max-width: ${max}px)`).matches);
  };
  const [isMobile,setIsMobile]=useState(get);
  useEffect(()=>{
    if(typeof window==="undefined"||!window.matchMedia) return;
    const mq=window.matchMedia(`(max-width: ${max}px)`);
    const sync=()=>setIsMobile(get());
    sync();
    if(mq.addEventListener) mq.addEventListener("change",sync);
    else mq.addListener(sync);
    window.addEventListener("resize",sync);
    window.visualViewport?.addEventListener("resize",sync);
    return ()=>{
      if(mq.removeEventListener) mq.removeEventListener("change",sync);
      else mq.removeListener(sync);
      window.removeEventListener("resize",sync);
      window.visualViewport?.removeEventListener("resize",sync);
    };
  },[max]);
  return isMobile;
}

export { ACTIVE_LANG, BEL, DEMO_USERS, DEU, FRA, GEO, LUX, MISSING_TRANSLATION_KEYS, N, NOTIF_REVERSE_T, NO_PHOTO_IMG, SEARCH_PAGE_TEXT, SEED, SEED_CONVOS, SEED_DEALS, SEED_REVIEWS, T, esc, fmtHour, fmtTime, genId, lanacFillNotifReverse, notifAutoI18n, pts, setActiveLang, toXY, tp, tpCap, tx, useIsMobile };
